import React, { useEffect, useState, lazy, Suspense } from 'react';
import './App.scss';
import intl from "react-intl-universal";
import http from "axios";
import { isZH_CN } from './utils';

const Header = lazy(() => import('./components/header'));
const Footer = lazy(() => import('./components/footer'));
const Routes = lazy(() => import('./routes'));



function App() {
  console.log('app');
  const langClass = isZH_CN() ? 'cn' : 'en';

  const [initDone, setInitDone] = useState(false);

  const loadLocales = () => {
    let currentLocale = intl.determineLocale({
      urlLocaleKey: "lang",
      cookieLocaleKey: "lang"
    });
    console.log('currentLocale', currentLocale);

    const langArr: string[] = currentLocale.split('-');
    currentLocale = langArr[0].toLowerCase() + '-' + langArr[1].toUpperCase();
    http
      .get(`/locales/${currentLocale}.json`)
      .then(res => {
        console.log("App locale data", res.data);
        // init method will load CLDR locale data according to currentLocale
        return intl.init({
          currentLocale,
          locales: {
            [currentLocale]: res.data
          }
        });
      })
      .then(() => {
        // After loading CLDR locale data, start to render
        setInitDone(true);
      });
  }

  useEffect(() => {
    loadLocales();
  }, [])

  return (
    initDone
      ? <div className={`App ${langClass}`}>
        <header className="App-header">
          <Suspense fallback={null}>
            <Header />
          </Suspense>
        </header>
        <div className="main">
          <Suspense fallback={<div></div>}>
            <Routes />
          </Suspense>
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
        </div>
      </div>
      : null
  );
}

export default App;
